export default "__VITE_ASSET__DRQXYayC__"